/* eslint-disable import/no-named-as-default */
import React from 'react';
import get from 'lodash/get';
import take from 'lodash/take';
import { useTranslation } from 'react-i18next';
import ListGroup from 'jbc-front/components/ListGroup';
import formatDate from 'src/utils/Date';
import styles from './SystemAnnounces.scss';

const MAX_DISPLAY = 5;

export const showDateNewLine = date => date.replace(/年/, '年\n');

const EmployeeAnnounces = ({ employeeAnnounces }) => {
  const { t } = useTranslation();
  return (
    <div>
      <ListGroup>
        <ListGroup.Title>
          {t('features.Dashbord.components.EmployeeAnnounces.notification_from_administrator')}
        </ListGroup.Title>
        {get(employeeAnnounces, 'length') > 0 ? (
          take(employeeAnnounces, MAX_DISPLAY).map(employeeAnnounce => (
            <ListGroup.Item
              className={styles.list}
              key={employeeAnnounce.id}
              {...{ href: `${employeeAnnounce.link}`, target: '_blank', as: 'a' }}
            >
              <span className={styles.date} style={{ marginRight: '8px' }}>
                {showDateNewLine(formatDate(employeeAnnounce.announceTime))}
              </span>
              <div className={styles.title}>{employeeAnnounce.body}</div>
              <ListGroup.Icon />
            </ListGroup.Item>
          ))
        ) : (
          <ListGroup.Item className={styles.empty}>
            {t('features.Dashbord.components.EmployeeAnnounces.no_announcement')}
          </ListGroup.Item>
        )}
      </ListGroup>
      {get(employeeAnnounces, 'length') > MAX_DISPLAY && (
        <div className={styles.more}>
          <a href="/employees/my_data/announces" className={styles.more}>
            {t('features.Dashbord.components.EmployeeAnnounces.show_all')}
          </a>
        </div>
      )}
    </div>
  );
};

export default EmployeeAnnounces;
